var config = {
    wwwroot:"50omsopsdist",
    subdomain: "logisticcore",//"50oms",
}

module.exports = config;